// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"884":"admin","933":"auth"}[chunkId] + "." + {"884":"80d802de","933":"a1d38ffa"}[chunkId] + ".css";
};